import { defineMessages } from 'react-intl';

export default defineMessages({
    legalMessage: {
        id: 'cep.components.sgCepFooter.legalMessage',
        // eslint-disable-next-line max-len
        defaultMessage: 'Saga Services Limited (Company no. 732602) is registered in England and Wales. Registered Office is 3 Pancras Square, London, N1C 4AG. Authorised and regulated by the Financial Conduct Authority under register no. 311557.'
    }
});
